<script>
    let code = `{
  "sourceOrderId":  "AB123",
  "items": [
       {
           "components":[ ]
       }
   ],
   "shipments": [
        {
            "shipTo": { },
            "returnAddress": { },
            "carrier": { }
        }
   ]
}
    `

</script>

<div class="card">
    <span class="syntax">{@html '{' }</span><br>
    &nbsp;&nbsp;&nbsp;"sourceOrderId":  "AB123", <br>
    &nbsp;&nbsp;&nbsp;"items": <span class="syntax">{@html '[' }</span><br>
    &nbsp;&nbsp;&nbsp;&nbsp;<span class="syntax">{@html '{' }</span><br>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"components": <span class="syntax">{@html '[ ]' }</span><br>
    &nbsp;&nbsp;&nbsp;&nbsp;<span class="syntax">{@html '}' }</span><br>
    &nbsp;&nbsp;&nbsp;<span class="syntax">{@html ']' }</span>,<br>
    &nbsp;&nbsp;&nbsp;"shipments": <span class="syntax">{@html '[' }</span><br>
    &nbsp;&nbsp;&nbsp;&nbsp;<span class="syntax">{@html '{' }</span><br>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"shipTo": <span class="syntax">{@html '{ }' }</span>,<br>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"returnAddress": <span class="syntax">{@html '{ }' }</span>,<br>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"carrier": <span class="syntax">{@html '{ }' }</span><br>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="syntax">{@html '}' }</span><br>
    &nbsp;&nbsp;&nbsp;&nbsp;<span class="syntax">{@html ']' }</span><br>
    <span class="syntax">{@html '}' }</span>


</div>

<style>
    @import url('http://fonts.cdnfonts.com/css/menlo');

    .card {
        padding: 50px;
        margin-top: 2rem;
        text-align: left;
        font-family: 'Menlo', sans-serif;
        font-size: 15px;
        font-weight: 200;
        background: #0B0938;
        border-radius: 10px;

    }

    .syntax {
        color: #3BA9E0;
    }

</style>